module.exports = __webpack_public_path__ + "img/fuwu2.a58a2fa7.png";